import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import PageTitle from '../../common/page-title/index';
import ContactForm from './contact-us-form';
import { getNewContact } from '../../../actions/contacts';
import TextViewer from '../../common/editor/text-viewer';

import '../styles.css';

class ContactUs extends Component {
  componentDidMount() {
    this.props.dispatch(getNewContact());
  }

  render() {
    return (
      <div className="contact-us">
        <Row>
          <Col>
            <PageTitle>Contact us</PageTitle>
          </Col>
        </Row>

        <TextViewer pageSlug='contact-us-pre-login'></TextViewer>

        <Row>
          <Col>
            <ContactForm enquiries={this.props.enquiries}/>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    enquiries: state.registration.contact.enquiries || []
  };
};

export default connect(mapStateToProps)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/contact-us/pre-login/index.jsx